var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRadio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Radiobutton"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 8724",
    d: "M18.4154 9.99967C18.4154 14.6481 14.6471 18.4163 9.9987 18.4163C5.3503 18.4163 1.58203 14.6481 1.58203 9.99967C1.58203 5.35128 5.3503 1.58301 9.9987 1.58301C14.6471 1.58301 18.4154 5.35128 18.4154 9.99967Z",
    strokeWidth: 1.5,
    stroke: "#DDE1ED"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadio);
export default __webpack_public_path__ + "static/media/radio.b11fa5fa8238e66b7cb9b13d7eb85066.svg";
export { ForwardRef as ReactComponent };